// extracted by mini-css-extract-plugin
export default {"BamboraInline":"bambora-inline-checkout_BamboraInline__frOZm"};